<template>
  <div>
    <p class="label --medium main_color_text">{{ component.title[0].value }}</p>
    <div class="element el-line-chart" :class="{ 'can-change': is_editable }">
      <div v-show="!hide" class="chart">
        <canvas ref="canvas" height="145" width="90"></canvas>
      </div>

      <!-- Display error div -->
      <error v-if="hide" :show-in-read-mode="true" />
    </div>
	<div class="box-edit" style="right:-500px" v-show="editor.mode == 'editing'">
        <div class="box-edit-line">
          <button @click="toggleHideManually()">{{hide?"Montrer":"Cacher"}} le graphique nature des acquéreurs</button>
        </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Chart from "chart.js";
import getParameter from "@/libs/get_parameter.js";
import ElementMixin from "@/components/study/editor/elements/element.mixin.js";
import error from "@/components/global/error.vue";

export default {
	components: { error },
	data: () => ({
		chart: null,
		error: false,
	}),
	mixins: [ElementMixin],
	props: {
		name: { default: "" },
		values: Object,
		componentName: { default: "nature acquereurs", type: String },
		componentId: { default: "4.5", type: String },
		theme: {
			type: String,
			default: "dynamique_marche_residentiel_promotion",
		},
	},
	computed: {
		...mapGetters(["editor", "etude_data"]),
		is_edit_mode: function () {
			const result = this.editor.mode == "editing";
			return result;
		},
		hide () {
			return (this.error || this.active_study.etudeData.hideChartAcquereur);
		},
		parameters () {
			try {
				const parameters = this.active_study.qlikData.parameters.editmode.find(
					(editmode) => {
						return editmode.theme == this.theme;
					}
				);

				return parameters;
			} catch (e) {
				return false;
			}
		},
		component () {
			return this.active_study.qlikData.component.find((component) => {
				return component.name == this.componentName || component.id == this.componentId;
			});
		},
		data () {
			this.error = false;

			try {
				const zoneGeo = this.getParameter(
					"zoneGeo",
					this.parameters.geo.default
				);

				let data;

				if (zoneGeo == "quartier") {
					data = this.component.content["quartiers"].find(
						(item) =>
							item.code == this.getParameter("zoneGeoQuartier", 0) &&
              item.period == this.getParameter("lastYearPeriod", this.parameters.periods.values[0].code)
					);
				} else if (zoneGeo == "secteurs_adequation") {
					data = this.component.content["secteurs_adequation"].find(
						(item) =>
							item.code == this.getParameter("zoneGeoSecteur", 0) &&
              item.period == this.getParameter("lastYearPeriod", this.parameters.periods.values[0].code)
					);
				} else {
					data = this.component.content[zoneGeo].find(
						(item) => item.period == this.getParameter("lastYearPeriod", this.parameters.periods.values[0].code)
					);
				}

				return data;
			} catch (e) {
				this.error = true;
			}
			return null;
		},
	},
	methods: {
		toggleHideManually () {
			this.$store.dispatch("edit_object",{
				obj: this.active_study.etudeData,
				field: "hideChartAcquereur",
				value: !this.active_study.etudeData.hideChartAcquereur
			});
		},
		getParameter (name, defaultValue) {
			return getParameter(this.etude_data, this.theme, name, defaultValue);
		},
		buildChart () {
			try {
				this.chart = new Chart(this.$refs.canvas, {
					type: "bar",
					data: {
						datasets: [
							{
								label: this.data.data_list[0].label,
								data: [this.data.data_list[0].values[0].value],
								backgroundColor: "#f3c461",
							},
							{
								label: this.data.data_list[1].label,
								data: [this.data.data_list[1].values[0].value],
								backgroundColor: "#59c38c",
							},
						],
					},
					options: {
						layout: {
							padding: 0,
						},
						hover: {
							mode: null,
						},
						legend: {
							position: "bottom",
							padding: 0,
							labels: {
								boxWidth: 10,
								fontSize: 10,
								padding: 5,
							},
						},
						tooltips: {
							enabled: false,
						},
						scales: {
							xAxes: [
								{
									stacked: true,
									gridLines: {
										drawOnChartArea: false,
										offsetGridLines: false,
									},
								},
							],
							yAxes: [
								{
									stacked: true,
									ticks: {
										// display: false
										stepSize: this.data.data_list[0].values[0].value,
										min: 0,
										max: 100,
										fontSize: 10,
										padding: 0,
										callback: function (value) {
											return value + "%";
										},
									},
								},
							],
						},
					},
				});
			} catch(e) {
				this.error = true;
				console.warn("Impossible de construire le chart acquereur.", e);
			}
		},
	},
	mounted () {
		this.buildChart();
		if(typeof this.active_study.etudeData.hideChartAcquereur == "undefined"){
			this.$store.dispatch("edit_object",{
				obj: this.active_study.etudeData,
				field: "hideChartAcquereur",
				value: false
			});
		}
	},
	watch: {
		data () {
			this.buildChart();
		},
	},
};
</script>
